import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PermissionsService} from '../../../../Services/permissions.service';
import {TypeaheadBase} from '../../../common/typeahead/typeahead-base';

@Component({
  selector: 'app-invoice-form-ar-ap',
  templateUrl: './invoice-form-ar-ap.component.html',
  standalone: false
})
export class InvoiceFormArApComponent extends TypeaheadBase implements OnInit {

  constructor(private permissionsService: PermissionsService) {
    super();
  }

  get isAdmin(): boolean {
    return this.permissionsService.Get('Admin');
  }

  get hasEntityPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditReceivableEntities') ||
      this.permissionsService.Get('EditPayableEntities') ||
      this.permissionsService.Get('AllEntities');
  }

  get hasItemPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditItems');
  }

  @Input() vm: any;
  @Input() isBankLoaded = false;
  @Input() submitted = false;
  // Control which parts of the AR/AP view this component renders
  @Input() showEntity = false;
  @Input() showPayments = true;
  // Render the applied payments table (AR/AP only)
  @Input() showAppliedTable = false;
  // Whether to show the contextual "New" dropdown menu next to the entity selector
  @Input() showNewMenu = true;
  // Render Bill/Ship address and Contact selection
  @Input() showAddressContact = false;
  // Bubble input change up to parent to reuse existing handler
  @Output() paymentAmountChange = new EventEmitter<void>();
  @Output() clearEntity = new EventEmitter<void>();

  entityTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm?.entityName, 15);

  // True only when a bank is selected
  get isBankSelected(): boolean {
    try {
      return !!this.vm?.payment?.header?.bank_id;
    } catch {
      return false;
    }
  }

  // When bank changes, clear dependent values if no bank is selected
  onBankChange(newBankId: any): void {
    const hasBank = !!newBankId;
    if (!hasBank) {
      // Clear payment-related fields so no values are provided without a bank
      if (this.vm?.payment?.header) {
        this.vm.payment.header.header_date = undefined;
        this.vm.payment.header.payment_type_id = undefined;
        this.vm.payment.header.number = undefined;
      }
      this.vm.paymentAmount = undefined;
    }
  }

  // Local helper mirrors the parent invoice-form.component.ts utility used in templates
  // Ensures this child can validate fields independently without relying on parent context
  isFieldEmpty(val: any): boolean {
    if (val === null || val === undefined) {
      return true;
    }
    if (typeof val === 'string') {
      return val.trim().length === 0;
    }
    return false;
  }

  ngOnInit(): void {
    // On initial render, if no bank is selected, ensure dependent values are cleared
    const currentBank = this.vm?.payment?.header?.bank_id;
    if (!currentBank) {
      this.onBankChange(currentBank);
    }
  }
}
